<!-- bbs > 행동관리 > 상세설정 -->
<template>
  <div class="content-wrap">
    <NaviBox/>
    <div class="tit-group02">
      <h2 class="tit">{{t('message.actionManagementDetailSettings')}}</h2>
    </div>
    <div class="content-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.code')}}<span class="imp">*</span></div>
          <div class="row">
            <div class="txt">{{behaviorCode}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.behaviorName')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input :placeholder="t('message.enterActionName')" v-model="behaviorTitle" :name="'behaviorTitle'" class="size04"/>
            <!-- <CustomTextField :placeholder="t('message.enterActionName')" v-model="behaviorTitle" :name="'behaviorTitle'"></CustomTextField> -->
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.category')}}<span class="imp">*</span></div>
          <div class="row">
            <Select v-bind="sortTypeSelect" v-model="sortType" :name="'sortType'" />
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.categoryType')}}<span class="imp">*</span></div>
          <div class="row">
            <Select v-bind="categoryIdxSelect" v-model="categoryIdx" :name="'categoryIdx'"/>
            <div class="col-dv">
              <c-btn01 :btnText="t('message.addOrEdit')" :btnType="'button'" @click="onClickCategoryDialog"/>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit ty01">
            {{t('message.detailedObservationItem')}}
            <c-tooltip :TooltipText="t('message.additionalOptionShownWhenUnsafeSelected')"/>
          </div>
          <div class="row">
            <Select v-bind="commentCntSelect" v-model="commentCnt" />
            <div class="col-dv">
              <div class="check-group">
                <v-checkbox v-model="multiYn" :label="t('message.multipleSelection')" true-value="Y" false-value="N"></v-checkbox>
              </div>
            </div>
            <div class="row-dv" v-for="(item, i) in behaviorComments" :key="i">
              <c-Input :placeholder="t('message.enterComment')" class="size04" v-model="item.commentTitle" :name="'behaviorComment'+i"/>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit ty01">
            {{t('message.tag')}}
            <c-tooltip :TooltipText="t('message.tagRegistrationGuide')"/>
          </div>
          <div class="row">
            <c-Input :placeholder="t('message.tagExample')" class="size04" v-model="tag" :name="'tag'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.isRequired')}}
          </div>
          <div class="row">
            <v-switch v-model="essentialYn" :name="'essentialYn'" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.changeInfo')}}
          </div>
          <div class="row">
            <c-btnText01 :btnText="historyCnt" @click="showDialog"/>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 :btnText="t('message.list')" @click.stop="onClickGoList()"/>
      </div>
      <div class="wr">
        <c-btn02 :btnText="t('message.delete')" @click="dialogPageDelModel=true" v-if="!utils.isEmpty(viewIdx)"/>
        <c-btn01 :btnText="t('message.registerOrUpdate')" :btnType="'submit'" @click="handleForm"/>
      </div>
    </div>
  </div>
  <DialogCategory
    v-model="categoryDialogModel"
    :popTitle="t('message.categoryType')"
    @close="closePopupCB"/>
  <!--삭제-->
  <c-dialog v-model="dialogPageDelModel"
            v-bind="dialogPageDelBind"
            @close="dialogPageDelModel=false"
            @confirm="confirmDelete"/>
  <!--변경정보-->
  <c-dialog v-model="dialogChangeNumModel"
            v-bind="dialogChangeNumBind"
            :dialogText="historyDialogText"
            @close="dialogChangeNumModel=false"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {useForm} from "vee-validate";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import {useRoute} from "vue-router";
import { useI18n } from 'vue-i18n';
import LogService from "@/services/log.service";
import dayjs from "dayjs";
const { t } = useI18n();

//store
const route = useRoute()
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
  behaviorTitle: yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const viewIdx = route.params.idx!='null'?route.params.idx:''
const categoryDialogModel = ref(false)
const dialogPageDelModel = ref(false)
const behaviorTitle = ref('')
const sortType = ref('1')
const categoryIdx = ref('')
const commentCnt = ref(0)
const multiYn = ref('')
const tag = ref('')
const essentialYn = ref('')
const behaviorCode = ref('')
const behaviorComments = ref([])
const dialogChangeNumModel = ref(false)
const historyCnt = ref(0)
const historyDialogText = ref('')

//ui
const sortTypeSelect = ref({items: [{name: t('message.behavior'), value: '1'}, {name: t('message.status'), value: '2'}]})
const categoryIdxSelect = ref({items: [{name: t('message.select'), value: ''}]})
const commentCntSelect = ref({items: [{name: '0', value: 0}, {name: '1', value: 1}, {name: '2', value: 2}, {name: '3', value: 3}, {name: '4', value: 4}, {name: '5', value: 5}
    , {name: '6', value: 6}, {name: '7', value: 7}, {name: '8', value: 8}, {name: '9', value: 9}, {name: '10', value: 10}]})
let dialogChangeNumBind = {
  dialogTit: t('message.changeInfoFormat'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}
const dialogPageDelBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//hook
onMounted(() => {
  if (!utils.isEmpty(viewIdx)) {
    let params = {
      idx: viewIdx
    }

    BbsService.getBehavior(params).then(
      (response:any) => {
        behaviorCode.value = response.result.idx
        behaviorTitle.value = response.result.behaviorTitle
        sortType.value = response.result.sortType
        categoryIdx.value = response.result.categoryIdx
        tag.value = response.result.tag
        essentialYn.value = response.result.essentialYn
        behaviorComments.value = response.result.behaviorCommentArr
        multiYn.value = response.result.multiYn
        historyCnt.value = response.result.historyCnt?response.result.historyCnt:0
        const commentLength = behaviorComments.value.length
        //watch에서 처리
        commentCnt.value = commentLength
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }

  getCategoryList()
})

//watch
watch(commentCnt, (newValue) => {
  let newCnt = newValue
  let oldCnt = behaviorComments.value.length
  if(newCnt > oldCnt){
    for (let i = 1; i <= newCnt; i++) {
      if (i > oldCnt) {
        let tempObj = { commentTitle:'' }
        behaviorComments.value.push(tempObj)
      }
    }
  }
  else if(newCnt < oldCnt){
    behaviorComments.value = behaviorComments.value.slice(0, newCnt)
  }
})

//function
const handleForm = async ()=>{
  if(import.meta.env.MODE == 'development') {
    onClickGoList()
  }
  else{
    const result = await validate(); // 전체 필드 검증 실행
    if(!result.valid)
      return

    let companyIdx = localStorage.getItem('companyIdx')

    let params = {
      idx:viewIdx,
      companyIdx: companyIdx,
      behaviorTitle: behaviorTitle.value,
      sortType: sortType.value,
      categoryIdx: categoryIdx.value,
      commentCnt: commentCnt.value,
      behaviorComments:behaviorComments.value,
      tag: tag.value,
      essentialYn: essentialYn.value,
      actionType:'1',
      multiYn:multiYn.value
    }

    BbsService.insertBehavior(params).then(
      (response:any) => {
        if(response.success)
          utils.movePage('/actionManagementList')
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
const onClickGoList = ()=>{
  utils.movePage('/actionManagementList')
}

const closePopupCB = (type)=>{
  categoryDialogModel.value=false
  if(type === 'refresh')
    getCategoryList()
}

const getCategoryList = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
    actionType:'1'
  }

  BbsService.getBehaviorCategoryList(params).then(
    (response:any) => {
      let resultArr = {items:[]}
      _.forEach(response.result, (val, key)=>{
        let tempObj = {name:val['categoryTitle'], value:val['idx']}
        resultArr.items.push(tempObj)
      })
      categoryIdxSelect.value = resultArr
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickCategoryDialog = ()=>{
  storeRef.popupType.value = '1'  //bbs타입
  categoryDialogModel.value=true
}

const showDialog=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'behavior',
    parentIdx: viewIdx
  }
  LogService.getLogList(params).then(
    (response:any) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach((row)=> {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeNumModel.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const confirmDelete=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  if(!companyIdx)
    utils.movePage('/login')
  let params = {
    companyIdx:companyIdx,
    deleteArr: [viewIdx],
  }

  BbsService.deleteBehavior(params).then(
    (response) => {
      if(response.success) {
        onClickGoList()
        snackText.value = 'success'
        snackbar.value = true
      }
      else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>


<style lang="scss">
</style>
